<template>
  <div class="ta-c" style="padding-top:calc((100vh - 64px) / 2 - 120px)">
	  <img class="mb20" src="../../assets/logo.png" style="width: 400px;">
    <p class="ta-c fw-b fs48" style="color: #858AB1;">欢迎使用上海教育科研数字平台</p>
  </div>
</template>

<script>
export default {
  methods: {},
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
</style>